import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { RefObjetFacture } from './ref-objet-facture.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { RefQuantiteFacture } from './ref-quantite-facture.model';

export class ObjetFacture {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idObjet: { key: 'idObjet' },
        fonctionnelId: { key: 'fonctionnelId' },
        idOperateur: { key: 'idOperateur' },
        raisonSocialeOperateur: { key: 'raisonSocialeOperateur', optional: true, default: '' },
        idCahier: { key: 'idCahier', converter: new (DataIdConverterFactory.build(Cahier, 'cahiers'))(), optional: true },
        annee: { key: 'annee' },
        quantite: { key: 'quantite' },
        refQuantiteFacture: { key: 'idRefQuantiteFacture', converter: new (DataIdConverterFactory.build(RefObjetFacture, 'refQuantiteFactureList'))() },
        estFacture: { key: 'estFacture', optional: true },
        checked: { key: 'checked', optional: true }
    };

    id: number;
    idObjet: number;
    fonctionnelId: string;
    idOperateur: number;
    raisonSocialeOperateur: string;
    cahier: Cahier;
    annee: number;
    quantite: number;
    refQuantiteFacture: RefQuantiteFacture;
    estFacture: boolean;
    checked?: boolean;
}
